import React from 'react';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';

// TODO: add publication date
// * ++add it to all pages

const SEOHelmet = ({ title, description, imageUrl, pageUrl, lang }) => {
  return (
    <Helmet>
      <html lang={lang || 'en'} />
      <title>{title}</title>
      <meta name="description" content={description} />

      {/* Hardcoded Author Meta Tag */}
      <meta name="author" content="Agata Boeckmann" />

      {/* Favicon */}
      <link rel="icon" href="src/images/favicon.png" type="image/png" />

      {/* Open Graph Tags */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      <meta property="og:image" content={imageUrl} />
      <meta property="og:url" content={pageUrl} />
    </Helmet>
  );
};

SEOHelmet.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  imageUrl: PropTypes.string.isRequired,
  pageUrl: PropTypes.string.isRequired,
  lang: PropTypes.string,
};

export default SEOHelmet;
